export const ProductRatingRptConstants ={
    GETALL_REQUEST: 'PRODUCTRATINGRPT_GETALL_REQUEST',
    GETALL_SUCCESS: 'PRODUCTRATINGRPT_GETALL_SUCCESS',
    GETALL_FAILURE: 'PRODUCTRATINGRPT_GETALL_FAILURE',

    GETEXPORT_REQUEST: 'PRODUCTRATINGRPT_GETEXPORT_REQUEST',
    GETEXPORT_SUCCESS: 'PRODUCTRATINGRPT_GETEXPORT_SUCCESS',
    GETEXPORT_FAILURE: 'PRODUCTRATINGRPT_GETEXPORT_FAILURE',

    LOADING_REQUEST: 'LOADING_REQUEST'
}